import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

export interface RedirectionParams {
  l: string[];
  q: Params;
  f: string;
}

@Injectable({
  providedIn: 'root'
})
export class RedirectionService {

  constructor() { }

  getParams(url: string): RedirectionParams {
    if (!url) {
      return null;
    }
    return {
      l: this.getPathSegments(url),
      q: this.getQueryParams(url),
      f: this.getFragment(url)
    };
  }

  private getPathSegments(url: string): string[] {
    const matches = url.match(/^\/([^\?\#]*)/i);
    if (matches && matches[1]) {
      const segments = matches[1].split('/');
      if (segments.length) {
        segments[0] = `/${segments[0]}`;
      }
      return segments;
    }
    return null;
  }

  private getQueryParams(url: string): Params {
    const matches = url.match(/\?([^#]*)/i);
    if (matches && matches[1]) {
      const queryParams: Params = {};
      matches[1].split('&').forEach(q => {
        const param = q.split('=');
        const key = decodeURIComponent(param[0]);
        const value = decodeURIComponent(param[1]);
        queryParams[key] = value;
      });
      return queryParams;
    }
    return null;
  }

  private getFragment(url: string): string {
    const matches = url.match(/#(.*)$/i);
    if (matches && matches[1]) {
      return decodeURIComponent(matches[1]);
    }
    return null;
  }
}
